import React from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import DropdownMenu from './DropdownMenu';
import logo from '../../../assets/img/logo/logo1.png';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';


const FreePlanButton = styled.button`
  background-color: #0071e1;
  color: white;
  border: 1px solid #0071e1;

  &:hover {
    background-color: #005cbf;
    border-color: #005cbf;
  }
`;


function PublicNavbar() {
  const history = useHistory();
  // Platform Categories and Items
  const platformCategories = [
    {
      title: 'Explore our platform',
      items: [
        { text: 'Platform Overview', href: '/platform/overview' },
       { text: 'Security & Privacy', href: '/company/security' },
        { text: 'Plans & Pricing', href: '/pricing' },
      ],

    },
  ];

  // Solutions Categories and Items
  const solutionsCategories = [

    {
      title: 'Use Cases',
      items: [
        { text: 'Product Roadmaps', href: '/use-cases/product-roadmap' },
        { text: 'Customer Insights', href: '/use-cases/customer-insights' },
        { text: 'Data-Driven Prioritization', href: '/use-cases/data-driven-prioritization' },
        { text: 'Reduce Churn', href: '/use-cases/reduce-churn' },
        { text: 'Strategic Product Planning', href: '/use-cases/strategic-product-planning' },
        { text: 'Cross-Team Collaboration', href: '/use-cases/cross-team-collaboration' },
        { text: 'Go-to-Market Alignment', href: '/use-cases/go-to-market-alignment' },
        { text: 'Market Trend Analysis', href: '/use-cases/market-trend-analysis' },
        { text: 'Competitive Advantage', href: '/use-cases/competitive-advantage' },
        { text: 'Operational Efficiency', href: '/use-cases/operational-efficiency' },
        { text: 'Customer Segment Identification', href: '/use-cases/customer-segment-identification' },
        { text: 'Complaint Resolution Tactics', href: '/use-cases/complaint-resolution-tactics' },
        { text: 'Crisis Management and Response', href: '/use-cases/crisis-management-and-response' },
        {
          text: 'Content and Marketing Strategy Refinement',
          href: '/use-cases/content-and-marketing-strategy-refinement',
        },
        { text: 'Employee Satisfaction and Engagement', href: '/use-cases/employee-satisfaction-and-engagement' },
        // {
        //   text: 'Sustainability and Social Responsibility Initiatives',
        //   href: '/use-cases/sustainability-and-social-responsibility-initiatives',
        // },
        // { text: 'Cultural and Demographic Insights', href: '/use-cases/cultural-and-demographic-insights' },
        // { text: 'Legal and Compliance Implications', href: '/use-cases/legal-and-compliance-implications' },
        // { text: 'Accessibility Improvements', href: '/use-cases/accessibility-improvements' },
        // { text: 'Technology Adoption and Utilization', href: '/use-cases/technology-adoption-and-utilization' },
        //
        // { text: 'Workplace Culture Enhancement', href: '/use-cases/workplace-culture-enhancement' },
        // { text: 'Employee Retention Strategies', href: '/use-cases/employee-retention-strategies' },
        // {
        //   text: 'Training and Development Needs Identification',
        //   href: '/use-cases/training-and-development-needs-identification',
        // },
        // { text: 'Internal Process Optimization', href: '/use-cases/internal-process-optimization' },
        // { text: 'Enhancing Leadership and Management', href: '/use-cases/enhancing-leadership-and-management' },
        // {
        //   text: 'Identifying and Mitigating Workforce Burnout',
        //   href: '/use-cases/identifying-and-mitigating-workforce-burnout',
        // },
        // {
        //   text: 'Improving Employee Recognition and Rewards',
        //   href: '/use-cases/improving-employee-recognition-and-rewards',
        // },
        // { text: 'Building a Feedback-Driven Culture', href: '/use-cases/building-a-feedback-driven-culture' },

      ],
    },
     {
      title: 'Teams',
      'items': [
        { 'text': 'Customer Experience', 'href': '/teams/customer-experience' },
        { 'text': 'Product Managers', 'href': '/teams/product-managers' },
        { 'text': 'Customer Service / Support', 'href': '/teams/customer-service-support' },
        { 'text': 'Sales', 'href': '/teams/sales' },
        { 'text': 'Marketing', 'href': '/teams/marketing' },
        { 'text': 'User Experience (UX) / User Interface (UI) Design', 'href': '/teams/ux-ui-design' },
        { 'text': 'Technical Support', 'href': '/teams/technical-support' },
        { 'text': 'Account Management', 'href': '/teams/account-management' },
        { 'text': 'Customer Success', 'href': '/teams/customer-success' },
        { 'text': 'Quality Assurance', 'href': '/teams/quality-assurance' },
        { 'text': 'Feedback & Research', 'href': '/teams/feedback-research' },
        { 'text': 'Community Management', 'href': '/teams/community-management' },
        { 'text': 'Product Development', 'href': '/teams/product-development' },
        { 'text': 'Compliance & Regulatory Affairs', 'href': '/teams/compliance-regulatory-affairs' },
      ],
    },
  ];

  // Company Categories and Items
  const companyCategories = [

    {
      title: 'Resources',
      items: [
        { text: 'Blog', href: '/company/blog' },
        { text: 'Help & Support', href: '/company/support' },
        { text: 'Security & Privacy', href: '/company/security' }
      ],
    },

    {
      title: 'Technology',
      items: [
        { text: 'Improve NPS with our Instant suggestions', href: '#careers' },
        { text: 'Churn reduction analysis', href: '#careers' },
        { text: 'Smart walkthroughes using AI', href: '#careers' },
        { text: 'Automatic roadmap suggestions', href: '#careers' },
        { text: 'AI session analysis', href: '#internships' },
      ],
    },
  ];
  const handleFreePlanClick = () => {
    history.push('/signup');
  };
  return (
    <Navbar expand='lg'>
      <Container>
        <Navbar.Brand href='/'>
          <img
            src={logo} // Assuming create-react-app public directory structure
            width='210' // Set width based on your preference or design requirements
            height='60' // Set height based on your preference or design requirements
            className='d-inline-block align-top'
            alt='Logo'
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls='basic-navbar-nav' />
        <Navbar.Collapse id='basic-navbar-nav' style={{ marginLeft: '100px' }}>
          <Nav className='ms-auto'>
            <DropdownMenu title='Platform' categories={platformCategories} />
            <DropdownMenu title='Solutions' categories={solutionsCategories} />
            <DropdownMenu title='Company' categories={companyCategories} />
            <Nav.Link  href='/pricing' style={{ color: 'rgb(33, 37, 41)' }}
                      className='nav-dropdown-title'>Pricing</Nav.Link>
            <Nav>
              <Nav.Link  href='/login' className='nav-dropdown-title'
                        style={{ color: 'rgb(33, 37, 41)' }}>Login</Nav.Link>
            </Nav>
            <FreePlanButton onClick={handleFreePlanClick} style={{ borderRadius: '7px', marginLeft: '20px' }}>
              Start free
            </FreePlanButton>

            {/* This Nav contains only the login, making it align to the right edge */}

          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default PublicNavbar;